module.exports = __webpack_public_path__ + "img/snownight.24ffc401.png";